import AxiosInstance from "./axiosInstance";

const loading = document.querySelector("#consultation-form-head #loading");

const sendOtpContainer = document.querySelector("#consultation-form-head #send-otp-container");
const sendOtpForm = document.querySelector("#consultation-form-head #send-otp");

const consultationContainer = document.querySelector("#consultation-form-head #send-consultation-container");
const consultationForm = document.querySelector("#consultation-form-head #send-consultation");

sendOtpForm.onsubmit = (e) => {
  e.preventDefault();
  loading.classList.remove("hide");

  const userTelInp = document.querySelector("#consultation-form-head #send-otp #user_tel_inp");
  const _userTelInp = document.querySelector("#consultation-form-head #send-consultation #user_tel_inp_");
  const _phone = userTelInp.value;

  AxiosInstance.post(
    '/user-send-otp',
    { _phone }
  )
    .then(res => {
      if (res.data.status) {
        _userTelInp.value = _phone;
        sendOtpContainer.classList.add("hide");
        consultationContainer.classList.remove("hide");

        return;
      }

      console.error(res);
      window.alert("خطایی پیش آمد! لطفا دوباره امتحان کنید.");
    })
    .catch(err => {
      console.error(err);
      window.alert("خطایی پیش آمد! لطفا دوباره امتحان کنید.");
    })
    .finally(() => {
      loading.classList.add("hide");
    });
}

consultationForm.onsubmit = (e) => {
  e.preventDefault();
  loading.classList.remove("hide");

  const user_tel_inp_ = document.querySelector("#send-consultation #user_tel_inp_");
  const user_otp_inp = document.querySelector("#send-consultation #user_otp_inp");
  const first_name = document.querySelector("#send-consultation #first_name");
  const last_name = document.querySelector("#send-consultation #last_name");
  const description = document.querySelector("#send-consultation #description");

  AxiosInstance.post(
    '/user-send-consultation',
    {
      user_tel_inp_: user_tel_inp_.value,
      user_otp_inp: user_otp_inp.value,
      first_name: first_name.value,
      last_name: last_name.value,
      description: description.value,
    }
  )
    .then(res => {
      if (res.data.status) {
        user_tel_inp_.disabled = true;
        user_otp_inp.disabled = true;
        first_name.disabled = true;
        last_name.disabled = true;
        description.disabled = true;

        document.querySelector("#consultation-form-head #send-consultation .btn").classList.add("hide");
        document.querySelector("#consultation-form-head #send-consultation .success").classList.remove("hide");

        return;
      }

      console.error(res);
      window.alert("خطایی پیش آمد! لطفا دوباره امتحان کنید.");
    })
    .catch(err => {
      console.error(err);
      if (err.response.status && err.response.status == 403)
        return window.alert("کد تایید نامعتبر است یا منقضی شده. لطفا دوباره امتحان کنید.");

      window.alert("خطایی پیش آمد! لطفا دوباره امتحان کنید.");
    })
    .finally(() => {
      loading.classList.add("hide");
    });
}
